Greenmile.MassiveSmartGeocode = Greenmile.MassiveSmartGeocode || {};
Greenmile.MassiveSmartGeocode.Map = function (smartGeocodeId, processId, locationId) {

    const id = locationId;
    const lengthSmartGeocode = Greenmile.MassiveSmartGeocode.data.size();
    let positionSmartGeocode = Greenmile.MassiveSmartGeocode.data.getPositionByLocationId(id);

    const removeCorrectPosition = function (map) {
        const layers = map._layers;

        for (let key in layers) {
            const layer = layers[key];

            if (typeof(layer.type) !== "undefined" && layer.type === "correctPosition") {
                map.removeLayer(layer);
            }
        }
    };


    const setCorrectLocation = function (latitude, longitude) {
        Greenmile.MassiveSmartGeocode.correctPosition = { latitude, longitude };
    };

    const addMarkerCorrectPosition = function (position, map) {
        removeCorrectPosition(map);

        const icon = L.divIcon({
            iconAnchor: [7.5,7.5],
            iconSize: [15, 15],
            html: '<div class="smartGeocodePointer"></div>'
        });

        const latlng = new L.LatLng(position.lat, position.lng);

        const marker = new L.marker(latlng, {
            icon: icon,
            clickable: true
        });

        marker.type = "correctPosition";
        marker.addTo(map);
        map.panTo(latlng);

        setCorrectLocation(position.lat, position.lng);
    };

    const goToNextSmartGeocode = function () {
        positionSmartGeocode += 1;

        if (positionSmartGeocode < lengthSmartGeocode) {
            const smartGeocode = Greenmile.MassiveSmartGeocode.data.at(positionSmartGeocode);
            const locationId = smartGeocode.attributes.location.id;
            const router = new App.Routers.MassiveSmartGeocode();
            
            router.goToScreen('map', { locationId });
        }
    };

    const updateAndGoToNextSmartGeocode = function () {
        const oldModel = Greenmile.MassiveSmartGeocode.data.at(positionSmartGeocode);
        positionSmartGeocode += 1;

        if (positionSmartGeocode < lengthSmartGeocode) {
            const smartGeocode = Greenmile.MassiveSmartGeocode.data.at(positionSmartGeocode);
            const locationId = smartGeocode.attributes.location.id;
            const router = new App.Routers.MassiveSmartGeocode();

            Greenmile.MassiveSmartGeocode.data.destroy(oldModel);
            positionSmartGeocode -= 1;
            router.goToScreen('map', { locationId });
        }
    };

    const goToPreviousSmartGeocode = function () {
        positionSmartGeocode -= 1;

        if (positionSmartGeocode >= 0) {
            const smartGeocode = Greenmile.MassiveSmartGeocode.data.at(positionSmartGeocode);
            const locationId = smartGeocode.attributes.location.id;
            const router = new App.Routers.MassiveSmartGeocode();

            router.goToScreen('map', { locationId });
        }
    };

    const updateFitBounds = function (map) {
        const layers = map._layers;
        const markers = [];

        for (let key in layers) {
            const layer = layers[key];

            if (typeof(layer.type) !== "undefined" && (layer.type === "correctPosition" || layer.type === "actualPosition" || layer.type === "listPosition")) {
                markers.push([layer._latlng.lat, layer._latlng.lng]);
            }
        }

        if (markers.length > 0) {
            map.fitBounds(markers);
        }

    };

    const goToGrid = function () {
        App.Objects.MassiveSmartGeocode.goToScreen('grid');
    };

    const savePosition = function (goToNext) {      
        const callback = goToNext ? updateAndGoToNextSmartGeocode : goToGrid;
        const router = new App.Routers.MassiveSmartGeocode();      
        router.savePosition(smartGeocodeId, processId, locationId, callback);
    };

    const rejectPosition = function (goToNext) {
        const callback = goToNext ? updateAndGoToNextSmartGeocode : goToGrid;
        const router = new App.Routers.MassiveSmartGeocode();
        router.discardSuggestion(smartGeocodeId, callback);
    };

    const enableSaveButtons = function () {
        const btnSave = document.querySelector("#SmartGeocode #save");
        const btnSaveAndNext = document.querySelector("#SmartGeocode #saveAndNext");
        btnSave.removeAttribute("disabled");
        if (lengthSmartGeocode > 1 && positionSmartGeocode !== lengthSmartGeocode - 1) {
            btnSaveAndNext.removeAttribute("disabled");
        }
    };

    this.formatContentPopupCurrentPosition = function (location) {
        const model = new App.Models.Location(location);
        let content = `
            <div class="mapPopup">
                <div>
                    <span>${Monet.I18n.getResourcesByKey('Smartgeocode.grid.key')}: </span>
                    ${model.attributes.key}
                </div>
                <div>
                    <span>${Monet.I18n.getResourcesByKey('Smartgeocode.grid.locationDescription')}: </span>
                    ${model.attributes.description}
                </div>
                <div>
                    <span>${Monet.I18n.getResourcesByKey('Smartgeocode.map.address')}: </span>
                    ${model.getItemsOfAddress().join(", ")}
                </div>
            </div>
        `;
        return content;
    };

    this.addCurrentMarker = function (location, map) {
        const icon = new L.Icon({
            iconUrl: require("static/images/map/markers/location.png"),
            iconSize: [20, 20],
            iconAnchor: [10, 10],
            popupAnchor: [37, -4]
        });

        const latlng = new L.LatLng(location.latitude, location.longitude);
        const marker = new L.marker(latlng, {
            icon: icon,
            clickable: true
        });

        const contentPopup = this.formatContentPopupCurrentPosition(location);

        marker.bindPopup(contentPopup).openPopup();
        marker.type = "actualPosition";
        marker.addTo(map);

        setCorrectLocation(location.latitude, location.longitude);
        updateFitBounds(map);
    };

    this.addEventListener = function () {
        const btnSave = document.querySelector("#SmartGeocode #save");
        const btnSaveAndNext = document.querySelector("#SmartGeocode #saveAndNext");
        const btnReject = document.querySelector("#SmartGeocode #reject");
        const btnRejectAndNext = document.querySelector("#SmartGeocode #rejectAndNext");
        const btnCancel = document.querySelector("#SmartGeocode #cancel");
        const btnPrevious = document.querySelector("#SmartGeocode #previous");
        const btnNext = document.querySelector("#SmartGeocode #next");

        btnSave.addEventListener("click", () => savePosition());
        btnSaveAndNext.addEventListener("click", () => savePosition(true));
        btnReject.addEventListener("click", () => rejectPosition());
        btnRejectAndNext.addEventListener("click", () => rejectPosition(true));
        btnCancel.addEventListener("click", goToGrid);
        btnPrevious.addEventListener("click", goToPreviousSmartGeocode);
        btnNext.addEventListener("click", goToNextSmartGeocode);

        btnSave.setAttribute("disabled", "disabled");
        btnSaveAndNext.setAttribute("disabled", "disabled");

        if (lengthSmartGeocode === 1 || positionSmartGeocode === lengthSmartGeocode - 1) {
            btnSaveAndNext.setAttribute("disabled", "disabled");
            btnRejectAndNext.setAttribute("disabled", "disabled");
            btnNext.setAttribute("disabled", "disabled");
        }

        if (positionSmartGeocode === 0 || lengthSmartGeocode === 1) {
            btnPrevious.setAttribute("disabled", "disabled");
        }

    };

    this.setLoadingInBtn = () => {
        const btnSave = document.querySelector("#SmartGeocode #save");
        const btnSaveAndNext = document.querySelector("#SmartGeocode #saveAndNext");
        const btnReject = document.querySelector("#SmartGeocode #reject");
        const btnRejectAndNext = document.querySelector("#SmartGeocode #rejectAndNext");
        const btnCancel = document.querySelector("#SmartGeocode #cancel");
        const btnPrevious = document.querySelector("#SmartGeocode #previous");
        const btnNext = document.querySelector("#SmartGeocode #next");

        const buttons = [btnSave, btnSaveAndNext, btnReject, btnRejectAndNext, btnCancel, btnPrevious, btnNext];
        for(let i = 0; i < buttons.length; i++) {
            const input = buttons[i];
            if(!input.disabled) {
                input.disabled = true;
            } 

            if(i < 4) {
                input.classList && input.classList.toggle("loader-spinner");
            }
        }
    };


    this.createMap = function () {
        const divMap = document.getElementById('smartGeocodeMap');
        divMap.setAttribute('class', 'background-map');

        const mapConfs = Greenmile.Map.Utility.getMapLocalStorageConfiguration();

        const map = Greenmile.Map.Utility.createDefaultMap("smartGeocodeMap");
        const baseLayer = Greenmile.Map.Utility.createBaseLayer();

        map.addLayer(baseLayer);

        const mapSourceControl = new Greenmile.Toolbar.Map.MapSourceControl(null, map);
        mapSourceControl.setSourceMap(mapConfs.supplierMap, map, { mapBaseLayer: baseLayer });

        //armazena a referência do baseLayer
        if (typeof Greenmile.MassiveSmartGeocode !== "undefined") {
            Greenmile.MassiveSmartGeocode.mapBaseLayer = baseLayer;
        }

        const clickOnMap = function (e) {
            addMarkerCorrectPosition(e.latlng, this);
            enableSaveButtons();
        };

        map.off('click', clickOnMap);
        map.on('click', clickOnMap.bind(map));

        return map;
    };

    this.addSuggestedMarker = function (position, map, location) {
        const point = [36, -16];

        L.Position = L.Icon.extend({
            options: {
                shadowUrl: null,
                iconUrl: require("static/images/map/markers/generic_marker_blue.png"),
                iconSize: [15, 26],
                iconAnchor: [7.5, 26],
                popupAnchor: point,
                className: ''
            }
        });
        
        const latlng = new L.LatLng(position.latitude, position.longitude);
        const marker = new L.marker(latlng, {
        icon: new L.Position({}),
            clickable: true
        });

        const date = (location.geocodingDate) ? Monet.Format.Date.formatToLocale(location.geocodingDate) : '-';
        const popupContent = `
            <div class="mapPopup">
                <span>${Monet.I18n.getResourcesByKey('Smartgeocode.grid.geocodingDate')}: </span>
                ${date}
            </div>
        `;

        marker.bindPopup(popupContent).openPopup();

            marker.type = "listPosition";

            marker.on('click', (point) => {
                addMarkerCorrectPosition(point.latlng, map);
                enableSaveButtons();
            })

            marker.addTo(map);
    };
};
